export default "__VITE_ASSET__BAbym6yu__"